import React from "react";

// CSS-only hover/focus bubble above the trigger. Renders children untouched when there's no content.
export default function Tooltip({ content, children, className }) {
  if (!content) return <>{children}</>;

  const classes = ["rma-nc-tooltip", className].filter(Boolean).join(" ");

  return (
    <span className={classes}>
      {children}
      <span role="tooltip" className="rma-nc-tooltip-bubble">
        {content}
        <span className="rma-nc-tooltip-arrow" />
      </span>
    </span>
  );
}
